module.exports = __webpack_public_path__ + "img/icon_drop_2.c8f57563.svg";